import React from "react";
import UnderConstruction from "../images/page_under_construction.png";

const Cites = () => {
  return (
    <div>
        <img
          className="page-under-construction"
          src={UnderConstruction}
          alt="page under construction"
        />
      </div>
  );
};

export default Cites;
